import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'
import filter from 'lodash/fp/filter'
import { TILE_PROVIDERS } from '@layers-frontend/commons/constants'

export const getFieldsTileOrder = get('fieldsTileOrder')

export const getFieldTileOrder = fieldId => pipe(getFieldsTileOrder, get(fieldId))

// Generic selector - filters tile orders by provider name
export const getFieldTileOrderByProvider = (fieldId, providerName) => state => {
  const allTileOrders = getFieldTileOrder(fieldId)(state)

  if (!allTileOrders) return []

  return filter(tileOrder => get('tileSubscription.tileProvider.name')(tileOrder) === providerName)(allTileOrders)
}

// Planet-specific selector
export const getPlanetFieldTileOrder = fieldId => state => getFieldTileOrderByProvider(fieldId, TILE_PROVIDERS.PLANET)(state)
